module.exports = __webpack_public_path__ + "img/dai-vault.37cc0061.svg";